import * as yup from 'yup'

import { IdentityDocumentStatus, IdentityDocumentType } from '@/constants'

export const STATUS_NOT_PRESENT_OR_STIPULATE = [
  IdentityDocumentStatus.NOT_PRESENT,
  IdentityDocumentStatus.STIPULATE,
]

export const identityDocumentSchema = yup.object({
  status: yup
    .mixed<IdentityDocumentStatus>()
    .oneOf(Object.values(IdentityDocumentStatus))
    .nullable()
    .default(null),
  document_type: yup
    .mixed<IdentityDocumentType>()
    .oneOf(Object.values(IdentityDocumentType))
    .nullable()
    .default(null),
  number: yup.string().trim().nullable().default(null).optional(),
  photo_id_verified: yup.boolean().default(false),
})
